export default class OwnershipContactCategory {
    id: number;
    isCrossProject: boolean;
    isCrossProjectChecked: boolean;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/OwnershipContactCategory.ts